export const REACT_APP_QURAN_COVER = '/image/cover.png';
export const REACT_APP_QURAN_RIGHT_FRAME = '/image/tazhib_right.png';
export const REACT_APP_QURAN_LEFT_FRAME = '/image/tazhib_left.png';
export const REACT_APP_QURAN_VERSE = '/image/sep.svg';
